export interface SeoConfig {
	title?: string
	keywords?: string
	description?: string
	robots?: string
}

export const DEFAULT_SEO: SeoConfig = {
	title: '京东e卡回收正规平台-礼品卡回收-购物卡回收网-京卡收',
	keywords:
		'京东e卡回收正规平台,礼品卡回收,购物卡回收网,京卡收,购物卡回收正规平台,京东e卡,加油卡,话费充值卡,物美美通卡,百联ok卡,天猫享淘卡,沃尔玛,大润发购物卡,骏卡益享卡,天虹购物卡,银泰百货,华润万家,盒马鲜生,永辉超市卡',
	description:
		'京卡收是一家购物卡回收正规平台，回收京东e卡、加油卡、话费充值卡、物美美通卡、百联ok卡、天猫享淘卡、沃尔玛、大润发购物卡、骏卡益享卡、天虹购物卡、银泰百货、华润万家、盒马鲜生、永辉超市卡等多种卡。即时到账，专业客服，平台自营，安全回收。',
}

export const ROUTE_SEO: Record<string, SeoConfig> = {
	home: DEFAULT_SEO,
	aboutUs: {
		title: '关于我们 - 京卡收购物卡回收正规平台',
		keywords: '京卡收,购物卡回收,礼品卡回收,卡券回收平台,大连辛壬葵',
		description:
			'京卡收是大连辛壬葵网络科技服务有限公司旗下卡券回收平台，致力于为用户提供安全、便捷、高效的购物卡、礼品卡回收服务，让每一张闲置卡券都发挥价值。',
	},
	news: {
		title: '卡券资讯 - 京卡收',
		keywords: '卡券新闻,礼品卡资讯,购物卡回收,京卡收',
		description: '京卡收卡券新闻资讯，了解购物卡、礼品卡回收行业动态与平台最新信息。',
	},
	dynamics: {
		title: '平台公告 - 京卡收',
		keywords: '京卡收公告,卡券回收动态,购物卡回收,京卡收',
		description: '京卡收平台公告与动态，及时了解卡券回收服务更新与重要通知。',
	},
	cooperation: {
		title: 'API合作 - 京卡收',
		keywords: 'API合作,卡券回收接口,京卡收,礼品卡回收',
		description: '京卡收提供卡券回收 API 接口合作，支持多种购物卡、礼品卡回收对接。',
	},
	official: {
		title: '微信公众号 - 京卡收',
		keywords: '京卡收公众号,购物卡回收,礼品卡回收,京卡收',
		description: '关注京卡收微信公众号，便捷进行购物卡、礼品卡回收，安全高效即时到账。',
	},
	noindex: {
		title: '京卡收',
		robots: 'noindex,nofollow',
	},
}

export const CARD_KEYWORDS =
	'京东e卡,礼品卡回收,购物卡回收,加油卡,话费充值卡,物美美通卡,百联ok卡,天猫享淘卡,沃尔玛,大润发购物卡,骏卡益享卡,天虹购物卡,银泰百货,华润万家,盒马鲜生,永辉超市卡,京卡收'
